import { useApolloClient } from '@apollo/client'
import { useAuthorizationContext } from '@emico-hooks/login-token'
import { useCallback } from 'react'

import { removeItemFromCart } from './removeItemFromCart'

export function useRemoveItemFromCart() {
    const client = useApolloClient()
    const authorizationContext = useAuthorizationContext()

    return useCallback(
        (cartId: string, cartItemUid: string, withRestore: boolean = false) =>
            removeItemFromCart(client, cartId, cartItemUid, withRestore, {
                context: authorizationContext,
            }),
        [authorizationContext, client],
    )
}
